<template>
  <v-flex>
    <v-progress-linear
      v-if="isLoading"
      class="ma-0"
      height="2"
      indeterminate/>

    <v-card flat>
      <v-card-title>
        <span class="headline">{{ $t('heading') }}</span>
        <v-spacer/>
        <v-select
          :label="$t('selectMonth')"
          :items="monthsWithTimesheets"
          v-model="selectedMonth"
        />

      </v-card-title>

      <v-data-table
        v-if="serverData"
        :items="serverData"
        v-model="selected"
        :rows-per-page-items="[15, 25, 50]"
        :total-items="pagination.totalItems"
        :pagination.sync="pagination"
        select-all
      >
        <template v-slot:headers="props">
          <tr v-if="serverData">
            <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"/>
            </th>
            <th colspan="3"/>
          </tr>
        </template>
        <template
          slot="items"
          slot-scope="props"
        >
          <tr
            :active="props.selected"
            @click="props.selected = !props.selected">
            <td width="10%">
              <v-checkbox
                :input-value="props.selected"
                primary
                hide-details
              />
            </td>
            <td
              class="pa-2"
              width="20%">
              {{ props.item.number }}
            </td>
            <td class="pa-2">
              {{ props.item.first_name }} {{ props.item.last_name }}
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-card-actions v-if="timesheetIdsToDelete.length">
        <v-spacer/>
        <v-btn
          color="error"
          @click="deleteDialog = true">{{ $t('delete') }}
        </v-btn>

        <confirm-dialog
          :is-open="deleteDialog"
          :dialog-header="$t('deleteHeader')"
          :dialog-body="$t('deleteBody')"
          :is-loading="isLoading"
          :is-delete="true"
          :confirm-button-text="$t('delete')"
          @confirm="deleteSelectedTimesheets"
          @dialogToggle="val => deleteDialog = val"
        />
      </v-card-actions>
    </v-card>

  </v-flex>
</template>

<script>
import timesheetsApi from '@/api/TimesheetApi'
import companyApi from '@/api/CompanyApi'
import ConfirmDialog from '@/components/global-components/confirmDialog/ConfirmDialog'

export default {
  name: 'CompanyDeleteTimesheets',
  components: { ConfirmDialog },
  data () {
    return {
      isLoading: false,
      monthsWithTimesheets: [],
      selectedMonth: '',
      serverData: null,
      pagination: {
        rowsPerPage: 25,
        page: 1
      },
      selected: [],
      deleteDialog: false
    }
  },
  computed: {
    timesheetIdsToDelete () {
      return this.selected
        .map(employee => {
          const timesheet = employee.time_sheets.find(timesheet => timesheet.month === this.selectedMonth)
          if (timesheet) {
            return timesheet.id
          }
          return null
        }).filter(el => el !== null)
    }
  },
  methods: {
    async loadMonthsWithTimesheets () {
      this.isLoading = true
      this.selectedMonth = ''
      this.serverData = null
      const months = await timesheetsApi.getMonthsWithTimesheets()
      this.monthsWithTimesheets = months.map(el => {
        const value = el
        const text = this.$moment(el, 'MM-YYYY').format('MM.YYYY')
        return { value, text }
      })
      this.isLoading = false
    },

    async loadEmployeesWithTimesheetsInMonth () {
      if (!this.selectedMonth) {
        return
      }
      this.isLoading = true
      const params = {
        month: this.selectedMonth
      }
      if (this.pagination) {
        params.per_page = this.pagination.rowsPerPage
        params.current_page = this.pagination.page
      }
      const result = await companyApi.getEmployees(params)
      this.serverData = result.data
      this.selected = []
      this.pagination = {
        page: result.current_page,
        rowsPerPage: result.per_page,
        totalItems: result.total
      }
      this.isLoading = false
    },

    toggleAll () {
      if (this.selected.length) {
        this.selected = []
      } else {
        this.selected = [...this.serverData]
      }
    },
    async deleteSelectedTimesheets () {
      this.isLoading = true
      this.deleteDialog = false
      await timesheetsApi.batchDeleteTimesheets(this.timesheetIdsToDelete)
      this.loadMonthsWithTimesheets()
      this.isLoading = false
    }
  },
  watch: {
    selectedMonth: 'loadEmployeesWithTimesheetsInMonth',
    'pagination.page': 'loadEmployeesWithTimesheetsInMonth',
    'pagination.rowsPerPage': 'loadEmployeesWithTimesheetsInMonth'
  },

  created () {
    this.loadMonthsWithTimesheets()
  },
  i18n: {
    messages: {
      en: {
        selectMonth: 'Select month',
        heading: 'Remove timesheets',
        deleteHeader: 'Confirm',
        deleteBody: 'Do you really want to delete the selected items? ',
        delete: 'Delete'
      },
      tr: {
        selectMonth: 'Ay seç',
        heading: 'Zaman çizelgelerini sil',
        deleteHeader: 'Onaylamak',
        deleteBody: 'Seçili öğeleri gerçekten silmek istiyor musunuz?',
        delete: 'silmek'
      },
      de: {
        selectMonth: 'Monat wählen',
        heading: 'Stundenzettel entfernen',
        deleteHeader: 'Bestätigung',
        deleteBody: 'Wollen Sie wirklich die gewählten Elemente entfernen?',
        delete: 'Entfernen'
      },
      ru: {
        selectMonth: 'Выберите месяц',
        heading: 'Удалить расписания',
        deleteHeader: 'подтвердить',
        deleteBody: 'Вы действительно хотите удалить выбранные элементы?',
        delete: 'Удалить'
      }
    }
  }
}
</script>

<style scoped>

</style>
